// 品牌命名常數（單一來源）
// see CLAUDE.md, architecture.md, BRAND_GUIDE.md, docs/BRAND_NAMING_RESEARCH.md
//
// 命名分層原則（Pat 2026-06-12 拍板 TAUKE POS，取代 04-27 的「店小二」方案）：
//   產品名（全球）：TAUKE POS（頭家 thâu-ke = 老闆；商標查證見 BRAND_NAMING_RESEARCH.md）
//   產品名（台灣中文）：掌收 POS
//   AI 人格（店長 UI / 推播 / LLM 自稱）：小掌櫃
//   內部（code / commit / DB schema / file path）：小紘 / 小暖 / 小倉（不變）
//
// 為什麼換掉「店小二」：曜夆科技「店小二Pos」已雙平台上架（台灣餐飲 POS 同業），
// 高度混淆風險；「TAUKE POS」與 Smart POS 通用詞群近似、TIPO 駁回風險。
//
// 為什麼分層：
//   - 店長心智負擔低（一個 AI 人格）
//   - 工程仍清晰（dev 一看 file 名就知是哪個 sub-agent）
//   - 進階用戶（燈塔合作夥伴）想知道時可揭露分工，做為信任 / 透明度 signal

export const PRODUCT_NAME = 'TAUKE POS';
export const PRODUCT_NAME_ZH = '掌收 POS';
export const PRODUCT_FULL = `${PRODUCT_NAME} 掌收`;
export const PRODUCT_TAGLINE = '一杯咖啡的價格，AI 幫你顧生意';

export const BRAND_NAME = '小掌櫃';          // AI 人格自稱
export const BRAND_TAGLINE = 'AI 店長助理';
export const BRAND_FULL = `${BRAND_NAME} · ${BRAND_TAGLINE}`;

/**
 * 內部分工代號 → 對外功能描述。
 * 給「設定 → 關於 → 小掌櫃是什麼」進階頁面用。
 */
export const INTERNAL_AGENTS = Object.freeze({
  xiaohong: {
    codename: '小紘',
    role: '對話腦',
    description: '即時問答 — 銷售 / 庫存 / 效期查詢',
  },
  xiaonuan: {
    codename: '小暖',
    role: '行銷腦',
    description: '每日 03:30 自動生成清庫存文案',
  },
  xiaocang: {
    codename: '小倉',
    role: '庫存腦',
    description: '每日 03:00 掃效期壓力 + 推薦消化菜品',
  },
});
